import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function UserViewDetails({ formData }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>View</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/info-circle.png" alt="" />
                </button>
            </OverlayTrigger>

            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body className='position-relative'>
                    <div className='position-absolute top-0 end-0 me-4 mt-3 cursor-pointer' onClick={handleClose} >
                        <img src="../images/png/close.png" width={12.55} height={12.55} alt="" />
                    </div>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Template Details</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form user-view-details-list'>
                        <div className='row mb-3'>
                            <div className="col-5">
                                <p>Template Name :</p>
                            </div>
                            <div className="col-7">
                                <span>{formData?.name}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-5">
                                <p>Category Name :</p>
                            </div>
                            <div className="col-7">
                                <span>{formData?.categoryId?.length > 0 ? (
                                    formData.categoryId.map((item, index) => (
                                        <span key={index}>{item.name}</span>
                                    ))
                                ) : (
                                    'N/A'
                                )}</span>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className="col-5">
                                <p>Status:</p>
                            </div>
                            <div className="col-7">
                                <span>{formData?.status === true ? 'Active' : 'Deactive'}</span>
                            </div>
                        </div>

                        <div className='row mb-3'>
                            <div className="col-5">
                                <p>Is Sample :</p>
                            </div>
                            <div className="col-7">
                                <span>{formData?.isSample === true ? 'Yes' : 'No'}</span>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UserViewDetails